<template>
  <div class="page-container">
    <Table
      ref="tableRef"
      :params="params"
      :request="searchData"
      tooltip-effect="light"
    >
      <template #search>
        <el-form-item>
          <el-button v-show="authList.includes('healthTask:add')" type="primary" icon="el-icon-plus" @click="addNew"
            >{{$t('elp.filter.add')}}</el-button
          >
        </el-form-item>
      </template>
      <el-table-column prop="templateName" :label="$t('collect.taskTemplates.taskTemplateName')" >
        <template #default="scope">
          {{ scope.row.templateName }}
          <!-- <a style="color: var(--el-color-primary);cursor: pointer;" @click="editInfo(scope.row)">{{ scope.row.templateName }}</a> -->
        </template>
      </el-table-column>
      <el-table-column prop="templateType" :label="$t('collect.taskTemplates.taskType')" >
        <template #default="scope">
          {{ scope.row.templateType == 0 ? $t('collect.taskTemplates.universalTemplate') : $t('collect.taskTemplates.modelSpecific')}}
        </template>
      </el-table-column>
      <el-table-column prop="runDays" :label="$t('collect.tasklist.taskRunDays')" />
      <el-table-column prop="runTimesPerDay" :label="$t('collect.tasklist.collectionsPerDay')" />
      <el-table-column prop="maxRecordTime" :label="$t('collect.tasklist.singleCollectionDuration')" />
      <el-table-column prop="minTimeInterval" :label="$t('collect.tasklist.minRunInterval')" />
      <el-table-column prop="createBy" :label="$t('activity.list.creator')"/>
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')" />
      <el-table-column :label="$t('activity.list.operation')" width="150" fixed="right">
        <template #default="{ row }">
          <el-button
            v-show="authList.includes('healthTask:terminate')"
            @click="editTask(row)"
            type="text"
            size="small"
            >{{$t('activity.list.edit')}}</el-button
          >
          <el-button
            style="color: #f56c6c;"
            v-show="authList.includes('healthTask:record')"
            @click="deleteTaskTemplate(row)"
            type="text"
            size="small"
            >{{$t('activity.packetjoin.delete')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>
    <el-dialog
      :title="title"
      top="5vh"
      v-model="dialogFormVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
      :width="detailform.templateType ? '80%' : '50%'"
    >
    <el-row :gutter="20">
      <el-col :span="detailform.templateType ? 10 : 24">
      <el-form
        label-position="left"
        ref="detailformRef"
        class="dialog-form"
        :model="detailform"
        :rules="detailformRules"
        :label-width="curLang == 'en-US' ? '240px' : '240px'"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('collect.taskTemplates.taskType')" prop="templateType">
              <el-radio-group v-model="detailform.templateType">
                <el-radio :label="0">{{$t('collect.taskTemplates.universalTemplate')}}</el-radio>
                <el-radio :label="1">{{$t('collect.taskTemplates.modelSpecific')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="detailform.templateType">
            <el-form-item :label="$t('collect.taskTemplates.subtask')" prop="canBeMultiTask">
              <el-radio-group v-model="detailform.canBeMultiTask">
                {{ detailform.canBeMultiTask }}
                <el-radio :label="true">{{$t('collect.taskTemplates.yes')}}</el-radio>
                <el-radio :label="false">{{$t('collect.taskTemplates.no')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('collect.taskTemplates.taskTemplateName')" prop="templateName">
              <el-input
                v-model="detailform.templateName"
                :placeholder="$t('collect.messagelist.taskName')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('collect.tasklist.taskRunDaysUnit')" prop="runDays">
              <el-input
                v-model="detailform.runDays"
                :placeholder="$t('collect.tasklist.taskRunDaysRange')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('collect.tasklist.executionsPerDayUnit')" prop="runTimesPerDay">
              <el-input
                v-model="detailform.runTimesPerDay"
                :placeholder="$t('collect.tasklist.executionsPerDayRange')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('collect.tasklist.maxRunTimeUnit')" prop="maxRecordTime">
              <el-input
                v-model="detailform.maxRecordTime"
                :placeholder="$t('collect.tasklist.maxRunTimeRange')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('collect.tasklist.minRunIntervalUnit')" prop="minTimeInterval">
              <el-input
                v-model="detailform.minTimeInterval"
                :placeholder="$t('collect.tasklist.minRunIntervalRange')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('collect.tasklist.programFilterMethod')" prop="isMatchProgramAccurately">
              <el-radio-group v-model="detailform.isMatchProgramAccurately">
                <el-radio v-if="!detailform.templateType" :label="-1">{{$t('collect.tasklist.mismatch')}}</el-radio>
                <el-radio :label="1">{{$t('collect.tasklist.exactMatch')}}</el-radio>
                <el-radio :label="0">{{$t('collect.tasklist.fuzzyMatch')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!detailform.templateType && detailform.isMatchProgramAccurately !== -1">
            <el-form-item :label="$t('collect.tasklist.programFilter')" prop="programNameFilter">
              <el-input
                v-model="detailform.programNameFilter"
                :placeholder="$t('collect.tasklist.programFilter')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!detailform.templateType && detailform.isMatchProgramAccurately !== -1">
            <el-form-item :label="$t('collect.tasklist.maxCollectionsPerProgram')" prop="singleProgramRecordTime">
              <el-input
                v-model="detailform.singleProgramRecordTime"
                :placeholder="$t('collect.tasklist.maxCollectionsPerProgramRange')"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </el-col>
      <el-col :span="14" v-if="detailform.templateType == 1">
      <el-button size="small" type="primary" @click="addRobot">{{$t('collect.tasklist.add')}}</el-button>
      <el-table :data="detailform.filterList" v-if="detailform.templateType == 1" height="450px">
        <el-table-column prop="robotModel" :label="$t('collect.taskTemplates.robotModel')">
          <template #default="scope">
            <el-select v-model="scope.row.robotModel" filterable placeholder="请选择">
              <el-option
                v-for="item in robotModelList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="programName" :label="$t('collect.taskTemplates.programFilterConditions')">
          <template #default="scope">
            <el-input
              v-model="scope.row.programName"
              :placeholder="$t('collect.taskTemplates.programFilterConditions')"
              clearable
            />
          </template>
        </el-table-column>
        <el-table-column prop="runTimes" :label="$t('collect.tasklist.maxCollectionsPerProgram')">
          <template #default="scope">
            <el-input
              v-model="scope.row.runTimes"
              :placeholder="$t('collect.tasklist.maxCollectionsPerProgram')"
              clearable
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('activity.list.operation')" width="100">
          <template #default="{ row }">
            <i class="el-icon-delete" @click="deleteRobot(row)"></i>
          </template>
        </el-table-column>
      </el-table>
      </el-col>
    </el-row>
      <template #footer>
        <el-button size="small" type="primary" @click="editSubmit"
          >{{$t('activity.list.confirm')}}</el-button
        >
      </template>
    </el-dialog>
    <el-dialog
      :title="$t('collect.tasklist.taskDetails')"
      top="5vh"
      v-model="dialogDetialVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
    >
      <el-descriptions title="" column="2" direction="vertical" border>
        <el-descriptions-item :label="$t('collect.tasklist.selectTemplate')">{{detailform.templateName}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.taskTemplates.taskType')">{{detailform.templateType}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.taskNumber')">{{detailform.taskId}}</el-descriptions-item>
        <el-descriptions-item :label="$t('activity.packetjoin.robotCode')">{{ detailform.robotSN }}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.healthscorelist.ctrlCabCode')">{{detailform.cabinetSN}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.taskRunDaysUnit')">{{detailform.runDays}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.executionsPerDayUnit')">{{detailform.runTimesPerDay}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.maxRunTimeUnit')">{{detailform.maxRecordTime}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.minRunIntervalUnit')">{{ detailform.minTimeInterval }}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.programFilterMethod')">{{ detailform.isMatchProgramAccurately ? $t('collect.tasklist.exactMatch') : detailform.programNameFilter ? $t('collect.tasklist.fuzzyMatch') : $t('collect.tasklist.mismatch')}}</el-descriptions-item>
        <el-descriptions-item v-if="detailform.isMatchProgramAccurately !== -1" :label="$t('collect.tasklist.programFilter')">{{detailform.programNameFilter}}</el-descriptions-item>
        <el-descriptions-item v-if="detailform.isMatchProgramAccurately !== -1" :label="$t('collect.tasklist.maxCollectionsPerProgram')">{{detailform.singleProgramRecordTime}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.collectionStatus')">{{ taskField.find(type => type.value === detailform.reportCollectStatus)?.label}}</el-descriptions-item>
        <el-descriptions-item :label="$t('activity.list.creator')">{{detailform.createBy}}</el-descriptions-item>
        <el-descriptions-item :label="$t('activity.list.createTime')">{{detailform.createTime}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/utils/request'
import { common } from '../../common/mixin'
import Table from '@/components/elp/table'
import dayjs from 'dayjs'
import { reactive, toRefs } from '@vue/reactivity'
import { ElMessageBox, ElMessage } from 'element-plus'
import { robotStatusMap } from '../../common/constant'
import { intValidator, } from '../../common/utils'
import { reqTaskTemplate, reqGetTaskTemplateDetail, reqDeleteTaskTemplate } from '@/api/robot'
import { useRouter } from 'vue-router'
import { standard } from '@/common/constant'
import { useI18n } from 'vue-i18n'
import { computed } from "vue"
import { useStore } from "vuex"
export default {
  components: {
    Table
  },
  mixins: [common],
  setup () {
    const store = useStore()
    const { t } = useI18n()
    const router = useRouter()
    const userInfo = window.localStorage.getItem('userInfo')
    const state = reactive({
      realTime: false, // 是否实时更新
      timer: null, // 定时器
      duration: 10, // 时长
      tableRef: null,
      query: {
        timeRange: [
          dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
          dayjs().format('YYYY-MM-DD') + ' 23:59:59'
        ]
      },
      queryRobot: {},
      page: 1,
      size: 10,
      total: 0,
      robotTotal: 0,
      dialogFormVisible: false,
      dialogDetialVisible: false,
      dialogTableVisible: false,
      tableDataList: [],
      robotDataList: [],
      tableRobotDataList: [],
      robotModelList: [],
      detailformRef: null,
      detailform: {
        runDays: '',
        runTimesPerDay: '',
        maxRecordTime: '',
        minTimeInterval: '',
        programNameFilter: '',
        isMatchProgramAccurately: -1,
        singleProgramRecordTime: 0,
        reportCollectStatus: null,
        id: null,
        filterList: [],
        templateType: null,
        templateName: '',
        canBeMultiTask: false
      },
      params: [
        {
          key: 'templateName',
          value: '',
          label: t('collect.taskTemplates.taskTemplateName')
        },
        {
          type: 'Date',
          key: 'timeRange',
          value: [
            dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
            dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          ],
          label: t('collect.tasklist.operationTime'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': t('activity.detail.to'),
            'start-placeholder': t('activity.list.startDate'),
            'end-placeholder': t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        }
      ],
      tableParams: [
        {
          key: 'robotId',
          value: '',
          label: t('activity.packetjoin.robotCode')
        }
      ],
      versionInfo: null,
      multipleSelection: [],
      statusList: robotStatusMap,
      toggleRowSelection: [],
      multipleTable: null,
      standard: standard,
      userInfo: userInfo ? JSON.parse(userInfo) : {},
      curLang: computed(() => store.state.lang),
      ifDetial: false,
      authList: JSON.parse(window.localStorage.getItem('authList')),
      title: ''
    })

    const detailformRules = reactive({
      taskName: {
        required: true,
        message: t('collect.tasklist.enterTaskName'),
        trigger: 'change'
      },
      runDays: intValidator({
        label: t('collect.tasklist.taskRunDays'),
        min: 0,
        max: 365
      }),
      runTimesPerDay: intValidator({
        label: t('collect.tasklist.executionsPerDay'),
        min: 0,
        max: 60
      }),
      maxRecordTime: intValidator({
        label: t('collect.tasklist.maxRunTime'),
        min: 30,
        max: 150
      }),
      minTimeInterval: intValidator({
        label: t('collect.tasklist.minRunInterval'),
        min: 1,
        max: 43200
      }),
      isMatchProgramAccurately: {
        required: true,
        message: t('collect.tasklist.enterProgramFilterMethod'),
        trigger: 'change'
      },
      singleProgramRecordTime: intValidator({
        label: '',
        min: 1,
        max: 100
      }),
      programNameFilter: {
        required: true,
        message: t('collect.tasklist.programFilter'),
        trigger: 'change'
      },
    })

    const searchData = async params => {
      const taskList = request('getCollectTaskTemplateList', params)
        .then(data => {
          data.total = parseInt(data.total)
          data.size = parseInt(data.size)
          data.current = parseInt(data.current)
          return data
        })
        .catch(error => {
          console.error(error)
        })
      return taskList
    }

    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      state.tableRef?.update()
    }

    const updateRobotPage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
    }

    const addNew = () => {
      state.ifDetial = false
      // state.robotDataList = []
      state.title = t('collect.taskTemplates.addNewTaskTemplate')
      for (let key of Object.keys(state.detailform)) {
        state.detailform[key] = ''
        state.detailform.isMatchProgramAccurately = -1
        state.detailform.templateType = 0
        state.detailform.filterList = []
      }
      state.dialogFormVisible = true
    }

    const editInfo = (item) => {
      state.ifDetial = true
      // state.robotDataList = []
      for (let key of Object.keys(state.detailform)) {
        state.detailform[key] = item[key]
        // state.detailform.isMatchProgramAccurately = -1
      }
      state.dialogDetialVisible = true
    }

    const addRobot = () => {
      const item = {
        robotModel: '',
        programName: '',
        runTimes: ''
      }
      state.detailform.filterList?.push(item)
    }

    const deleteRobot = async row => {
      try {
        await ElMessageBox.confirm(t('activity.list.confirmDelete'), {
          confirmButtonText: t('activity.list.confirm1'),
          cancelButtonText: t('activity.list.cancel'),
          type: 'warning'
        })
        state.detailform.filterList = state.detailform.filterList.filter(item => {
          return item !== row
        })
        state.tableRef?.update()
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.packetreceive.deleteSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }

    const editSubmit = async () => {
      console.log(state.detailform)
      if(state.detailform.isMatchProgramAccurately == -1){
        state.detailform.singleProgramRecordTime = 0
      }
      try {
        state.detailformRef && (await state.detailformRef.validate())
        // if( state.robotDataList.length == 0 ) {
        //   ElMessage({
        //     showClose: true,
        //     type: 'warning',
        //     message: t('collect.tasklist.addRobot')
        //   })
        //   return false
        // }
        if(state.detailform.id == ''){
          await request('requestCreateTaskTemplate', state.detailform)
        }else{
          reqTaskTemplate(state.detailform)
        }
        state.dialogFormVisible = false
        state.tableRef?.update()
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }

    // 删除模板
    const deleteTaskTemplate = async (row) => {
      ElMessageBox({
        title: t('activity.packetreceive.prompt'),
        message: t('activity.list.confirmDelete'),
        type: 'warning',
        showCancelButton: 'true',
        confirmButtonText: t('activity.list.confirm1'),
        cancelButtonText: t('activity.list.cancel'),
      }).then(async () => {
        reqDeleteTaskTemplate(row.id)
        state.tableRef?.update()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.packetreceive.deleteSuccess')
        })
      }).catch(() => {
      })
    }

    // 编辑任务模版
    const editTask = async row => {
      // state.robotDataList = []
      state.title = t('collect.taskTemplates.editNewTaskTemplate')
      for (let key of Object.keys(state.detailform)) {
        state.detailform[key] = row[key]
        // state.detailform.isMatchProgramAccurately = -1
      }
      state.dialogFormVisible = true
    }

    const handleSizeChange = val => {
      state.size = val
    }

    const handleCurrentChange = val => {
      state.page = val
    }

    const getRobotModelList = async () => {
      try {
        const res = await request('getRobotModelList', {modelName: ''})
        state.robotModelList = res
      } catch (error) {
        console.error(error)
      }
    }
    getRobotModelList()
    return {
      ...toRefs(state),
      handleSizeChange,
      handleCurrentChange,
      detailformRules,
      searchData,
      updatePage,
      updateRobotPage,
      addNew,
      editInfo,
      deleteRobot,
      editSubmit,
      addRobot,
      editTask,
      deleteTaskTemplate
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.el-icon-delete {
  cursor: pointer;
}
:v-deep(.el-progress-circle_track) {
  color: aquamarine;
}
:deep(.el-form--label-left .el-form-item__label) {
  text-align: right;
}
</style>
